var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14BAD8",
    fillRule: "evenodd",
    d: "M6.679 3C6.304 3 6 2.553 6 2c0-.553.304-1 .679-1H23.32c.375 0 .679.447.679 1 0 .553-.304 1-.679 1H6.68zm0 8C6.304 11 6 10.553 6 10c0-.553.304-1 .679-1H23.32c.375 0 .679.447.679 1 0 .553-.304 1-.679 1H6.68zm0 8C6.304 19 6 18.553 6 18c0-.553.304-1 .679-1H23.32c.375 0 .679.447.679 1 0 .553-.304 1-.679 1H6.68zM2 4a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueList);
export default __webpack_public_path__ + "static/media/blue-list.d6fe618e6a99b60a4cca96b4e3ea3094.svg";
export { ForwardRef as ReactComponent };